import React from 'react'

import { PageHeader, Descriptions, Statistic } from 'antd'
import Moment from 'moment'
import { DATE_FORMAT } from '../../../../../core/utils/i18n-js'
import StatisticAmount from '../../../../../core/components/widget/amountInline/statistic'

import {
  INVOICE_STATUS_IN_REVIEW
} from '../../../../../components/invoice/status/const'

import { useHistory, useParams } from 'react-router-dom'

import { useFetch, useDownload, useRemoveAttachment, useUploadAttachment } from '../../../../../hooks/vendor/invoice'
import { useDownload as useDownloadPurchaseOrder } from '../../../../../hooks/vendor/purchaseOrder'
import { useDownload as useDownloadPayment } from '../../../../../hooks/vendor/payment'

import PaymentList from './payments'
import AttachmentHeader from './attachment'
import DetailsHeader from './details'

import Loader from '../../../../../components/loader'

const Content = ({ children, extra }) => {
  return (
    <div className='content'>
      <div className='main'>{children}</div>
      <div className='extra'>{extra}</div>
    </div>
  )
}

const extraContent = (data) => (
  <div
    style={{
      display: 'flex',
      width: 'max-content',
      justifyContent: 'flex-end'
    }}
  >
    <Statistic
      title='Status'
      value={data.invoice.status}
      style={{ marginRight: 32 }}
      valueStyle={{ color: '"#7e807f' }}
    />

    <StatisticAmount
      title='Amount'
      value={data.invoice.amount_value}
      prefix={data.invoice.amount_type}
    />
  </div>
)


const Show = (props) => {
  const history = useHistory()
  const onPressBack = () => history.goBack()
  const { id } = useParams()
  const { data, isLoading, isError } = useFetch(id)

  const vendorName = data?.invoice?.vendor?.name

  const { mutate: downloadInvoice, isLoading: isDownloadInvoiceLoading } = useDownload()
  const { mutate: uploadAttachment, isLoading: isUploadLoading } = useUploadAttachment(id)
  const { mutate: removeAttachment, isLoading: isRemoveLoading } = useRemoveAttachment()

  const { mutate: downloadPurchaseOrder, isLoading: isDownloadPurchaseOrderLoading } = useDownloadPurchaseOrder()
  const { mutate: downloadReceipt, isLoading: isDownloadReceiptLoading } = useDownloadPayment()

  const actionLoading = isDownloadInvoiceLoading || isDownloadPurchaseOrderLoading || isRemoveLoading || isUploadLoading || isDownloadReceiptLoading

  if (isLoading) {
    return (<Loader loading />)
  }

  if (isError) {
    return (<>Error</>)
  }

  return (
    <>
      <div className='site-page-header-ghost-wrapper'>
        <PageHeader
          ghost={false}
          className='site-page-header'
          onBack={onPressBack}
          title={`${data.invoice.display_id} / ${data.invoice.code}`}
          subTitle='Invoice'
        >
          <Content extra={extraContent(data)}>
            <Descriptions size='medium' column={2}>
              <Descriptions.Item label='Vendor'>{data.invoice?.vendor?.name}</Descriptions.Item>
              <Descriptions.Item label='Date'>
                {' '}
                {Moment(data.invoice.date).format(DATE_FORMAT)}{' '}
              </Descriptions.Item>
              <Descriptions.Item label='Notes'> {data.invoice.notes} </Descriptions.Item>
            </Descriptions>
          </Content>
        </PageHeader>
      </div>
      <br />

      <AttachmentHeader
        attachment={data.invoice?.attachment}
        onUpload={uploadAttachment}
        onDownload={() => downloadInvoice({ id: data.invoice?.id, name: data.invoice?.attachment.name })}
        onRemove={() => removeAttachment(data.invoice.id)}
        allowRemove={data.invoice.status === INVOICE_STATUS_IN_REVIEW}
        isLoading={actionLoading}
      />

      <br />
      {(data.payments || []).length > 0 && (
        <PaymentList
          payments={data.payments}
          onDownloadReceipt={downloadReceipt}
          actionLoading={actionLoading}
        />
      )}
      <br />

      <DetailsHeader
        details={data.invoice?.vendor_details || []}
        isLoading={isLoading}
        vendorName={vendorName}
        downloadPurchaseOrder={downloadPurchaseOrder}
      />
    </>
  )

}

export default Show

/*
export default class Show extends React.Component {
  constructor(props) {
    super(props)
  }

  _goBack = () => {
    this.props.history.goBack()
  }

  render () {
    const {
      data,
      actionLoading,

      uploadAttachment,
      downloadInvoice,
      removeAttachment,

      downloadReceipt,
      downloadPurchaseOrder,
      vendorName
    } = this.props

    return (
      <>
        <div className='site-page-header-ghost-wrapper'>
          <PageHeader
            ghost={false}
            className='site-page-header'
            onBack={this._goBack}
            title={`${data.invoice.display_id} / ${data.invoice.code}`}
            subTitle='Invoice'
          >
            <Content extra={extraContent(props)}>
              <Descriptions size='medium' column={2}>
                <Descriptions.Item label='Vendor'>{data.invoice?.vendor?.name}</Descriptions.Item>
                <Descriptions.Item label='Date'>
                  {' '}
                  {Moment(data.invoice.date).format(DATE_FORMAT)}{' '}
                </Descriptions.Item>
                <Descriptions.Item label='Notes'> {data.invoice.notes} </Descriptions.Item>
              </Descriptions>
            </Content>
          </PageHeader>
        </div>
        <br />

        <AttachmentHeader
          attachment={data.invoice?.attachment}
          onUpload={(form) => uploadAttachment(data.invoice.id, form)}
          onDownload={() => downloadInvoice(data.invoice?.id, data.invoice?.attachment.name)}
          onRemove={() => removeAttachment(data.invoice.id)}
          allowRemove={data.invoice.status === INVOICE_STATUS_IN_REVIEW}
          isLoading={actionLoading}
        />

        <br />
        {(data.payments || []).length > 0 && (
          <PaymentList
            payments={data.payments}
            onDownloadReceipt={downloadReceipt}
            actionLoading={actionLoading}
          />
        )}
        <br />

        <DetailsHeader
          details={data.invoice?.vendor_details || []}
          isLoading={loading}
          vendorName={vendorName}
          downloadPurchaseOrder={downloadPurchaseOrder}
        />
      </>
    )
  }
}
*/

